
import LinkButton from 'Src/js/components/LinkButton.vue';
import { defineComponent } from 'vue';
export default defineComponent({
	name: 'ReviewBlock',
	components: {
		LinkButton
	},
	emits: ['edit'],
	props: {
		title: {
			type: String,
			required: true,
		},
	},
});
